var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.79 16.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f47b20;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.4,
    cy: 8.4,
    r: 8.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "WMlxVZ"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.83,7.27h2.48c.21,0,.3.1.3.31,0,.71,0,1.42,0,2.14a.29.29,0,0,1-.31.3H9.81v.1c0,.81,0,1.62,0,2.43a.3.3,0,0,1-.33.32c-.7,0-1.41,0-2.11,0A.29.29,0,0,1,7,12.54c0-.81,0-1.61,0-2.41V10H4.48c-.21,0-.3-.1-.3-.31V7.57a.26.26,0,0,1,.29-.3h2.6s0-.07,0-.1c0-.82,0-1.64,0-2.46a.26.26,0,0,1,.3-.29H9.55c.2,0,.29.1.29.3,0,.81,0,1.62,0,2.43Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.bfbb39bec723aec4efab87ff5c4a2e4a.svg";
export { ForwardRef as ReactComponent };